import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "5-critical-foam-roof-checks-before-phoenix-monsoon-season";
export const Route = createFileRoute("/5-critical-foam-roof-checks-before-phoenix-monsoon-season")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
